// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"5706cd2a","453":"60ef11f8","462":"89ad8bdd","537":"31fe8ee0"}[chunkId] + ".chunk.js";
};